<template>
    <div>
        <attached-fs-modal ref="fs-modal"></attached-fs-modal>
        <ui-crud title="Defects" :subtitle="!packageReference?'List of all defects':'Manage package defects'"
                 ref="crud"
                 :fetch="fetch"
                 :pipe-with="pipeItems"
                 :group-by="groupByStatus"
                 :read-only="!packageReference">
            <template #new-button>
                <div class="flex items-center">
                    <h1 class="text-lg font-medium text-gray-900">Defects</h1>
                    <ui-button-new small class="ml-auto hidden sm:inline-flex" icon="fas fa-plus"
                                   v-if="packageReference"
                                   @click.prevent="createNew()">New
                    </ui-button-new>
                </div>
                <p class="mt-1 text-sm text-gray-600" v-if="packageReference">All Defects for this package</p>
                <ui-button-new class="sm:hidden mt-4" icon="fas fa-plus" v-if="packageReference"
                               @click.prevent="createNew()">New
                </ui-button-new>
            </template>

            <!-- Filters. -->
            <template #filters="{ debouncedRefresh }">
                <div class="relative">
                    <ui-input class="mt-6" field="bg-gray-50 pr-10" name="search" v-model="search"></ui-input>
                    <div class="absolute right-0 inset-y-0 h-full flex items-center justify-center p-3 text-gray-400">
                        <i class="fas fa-search"></i>
                    </div>
                </div>
            </template>

            <!-- List item. -->
            <template #list-item="{ item, select, active, setEditMode }">
                <ui-crud-card
                    :title="'Defect '+(''+item.reference)"
                    :subtitle="item.formatted_date"
                    :metadata="item.status"
                    :active="active"
                    @click="selectItem(item,select,setEditMode)"
                ></ui-crud-card>
            </template>

            <!-- Create form. -->
            <template #create="{ addItem, setEditMode, selectItem }">
                <div class="flex space-x-8 pt-4 px-4 m-4 justify-center items-center">
                    <div
                        class="border border-grey-200 rounded-l bg-gray-50 w-full h-full p-4 justify-center items-center text-center text-gray-500">
                        <-- Please select an existing Defect to view/edit or click new to create a new one.
                    </div>
                </div>
            </template>

            <template #edit="{ selectedItem, setEditMode, removeItem }">
                <defect-form
                    :package-reference="packageReference" :package-name="packageName"
                    :item="selectedItem"
                    :setEditMode="setEditMode"
                    @finishAndSend="finishAndSend(setEditMode)"
                    :fs-modal="$refs['fs-modal']"
                ></defect-form>
            </template>

            <!-- Show page. -->
            <template #show="{ selectedItem, setEditMode, removeItem, addItem, selectItem }">
                <defect-show
                    :package-reference="packageReference" :package-name="packageName"
                    ref="defectShow"
                    :item="selectedItem"
                    :removeItem="removeItem"
                    :setEditMode="setEditMode"
                    :search="search"
                    :fs-modal="$refs['fs-modal']"
                ></defect-show>
            </template>
        </ui-crud>
    </div>
</template>

<script>
import {Defect} from '@models'
import UiButtonNew from "../../ui/UiButtonNew.vue";
import {uuid} from "../../../utils";
import UiCrudCard from "../../ui/UiCrudCard.vue";
import UiCrud from "../../ui/UiCrud.vue";

export default {
    components: {UiCrud, UiCrudCard, UiButtonNew},
    props: {
        packageReference: null,
        packageName: null,
        showWhenLoaded: null
    },
    data() {
        return {
            search: '',
        }
    },
    methods: {
        finishAndSend(setEditMode) {
            setEditMode(false);

            this.$nextTick(() => {
                this.$refs.defectShow.send();
            })
        },
        async createNew() {
            let id = uuid();
            try {
                await Defect.create(this.packageReference, {
                    id: id,
                    packageReference: this.packageReference,
                    packageName: this.packageName
                });
                await this.$refs.crud.fetchItems();
                this.$nextTick(() => {
                    this.$refs.crud.selectItem(this.$refs.crud.items.find((i) => i.id === id), true);
                })
            } catch (error) {
                let body = JSON.parse(error.request.response);
            }
        },
        getItemTitle(item) {
            if (item.status === 'Draft') {
                return '<span class="text-gray-400">Draft #' + item.referenceNumber + '</span> - ' + item.formatted_date;
            }
            return '#' + item.referenceNumber + ' - ' + item.formatted_date;
        },
        selectItem(item, select, setEditMode) {
            select()
            setEditMode(false)
        },
        async fetch(itemId) {
            this.loaded = false
            this.items = await Defect.all(this.packageReference)
            if (itemId) {
                this.$refs.crud.selectItem(this.items.find((i) => i.id === itemId))
            } else if (this.items.length) {
                this.$refs.crud.selectItem(this.items[0])
            }
            this.loaded = true
            return this.items;
        },
        pipeItems(items) {
            const query = this.search.toLowerCase().split(/[^A-Za-z0-9.-]+/);
            if (query.length) {
                return items.filter((pr) => {
                    return (this.$refs.crud.selectedItem && (pr.id == this.$refs.crud.selectedItem.id)) || query.every((token) => {
                        return pr.tokens.includes(token);
                    })
                });
            }
            return items;
        },
        groupByStatus(item) {
            return item.status;
        },
    },
    async mounted() {
        if (this.showWhenLoaded) {
            this.$refs.crud.fetch(this.showWhenLoaded)
        }
    }
}
</script>
